import {Injectable} from '@angular/core';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {Orders} from '../models/orders.model';
import {OrdersFilter} from '../models/orders-filter.model';
import {DeliveryChecksList} from '../models/delivery-checks-list.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {OrderDetails} from '../models/order-details.model';
import {RequestMethod, RequestOptionsArgs, Response, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/zip';
import {Tyres} from '../models/tyres.model';
import {OrderDelivery} from '../models/order-delivery.model';
import {DeliveryUtilities} from '../utilities/delivery-utilities.model';
import {ListService} from '@shared/models/list-service.model';
import {OrderResponseChecks, OrderResponseDelivery, OrderResponseDetails, OrderResponseTyres} from '../models/orders-response.model';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {Subject, throwError, zip} from 'rxjs';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {catchError, map, tap} from 'rxjs/operators';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {PermissionService} from '@shared/service/permission.service';
import {NemoModuleKeys} from '@shared/models/user-permission.model';
import {CommodityModel} from '@shared/models/commodity.model';

@Injectable()
export class OrderService implements ListService {
	static STATE_READY: string = 'ready'; // torna orderDetails
	static STATE_SAVE_REMOVE_READY: string = 'save_remove_ready'; // torna orderDetails
	static STATE_SUSPEND: string = 'suspend'; // torna orderDetails

	static VENDOR_DOCUMENT_TYPE_INSURANCE_CERTIFICATES: string = 'insurance_certificates';
	static VENDOR_DOCUMENT_TYPE_REGISTRATION_BOOKS: string = 'registration_books';


	static DOCUMENT_TYPE_CERTIFICATE: string = 'certificate';
	static DOCUMENT_TYPE_LETTER: string = 'letter';

	environment: AppConfigEnvironment;

	deliveryTyreHasBeenCleanedObservable: Observable<boolean>;
	protected deliveryTyreHasBeenCleanedSubject: Subject<boolean>;

	citizenship: string;
	place_document_issue: string;
	delegate_citizenship: string;
	delegate_place_document_issue: string;

	constructor(
		private httpAuthService: HttpAuthService,
		private selectCommoditiesService: SelectCommoditiesService,
		private appConfig: AppConfigEnvironmentService,
		private permissionsService: PermissionService
	) {
		this.environment = appConfig.Environment;

		this.deliveryTyreHasBeenCleanedSubject = new Subject<boolean>();
		this.deliveryTyreHasBeenCleanedObservable = this.deliveryTyreHasBeenCleanedSubject.asObservable();
	}

	getCitizenshipParameter(citizenship:string, place_document_issue: string, delegate_citizenship: string,delegate_place_document_issue: string): void {
		this.citizenship = citizenship;
		this.place_document_issue = place_document_issue;
		this.delegate_citizenship = delegate_citizenship;
		this.delegate_place_document_issue = delegate_place_document_issue;
	}

	getOrdersDash(asr?: boolean): Observable<any> {
		let url: string = this.environment.GW_API + '/orders/dashboard';
		if (asr) {
			url = url + '?cod_delivery_class=PREREADYING';
		}
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		return new Observable<Orders>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							const value: any = {res: response.json(), commoditiesID: this.selectCommoditiesService.getAldCommodityIds()};
							observer.next(value);
						} else {
							observer.next(null);
						}
					},
					error => {
						console.error(error);
						observer.next(null);
					});
			});
	}

	getList(orderFilter: OrdersFilter): Observable<Orders> {
		let url: string = this.environment.GW_API + '/orders';
		if (orderFilter) {
			url = url + orderFilter.getFilterUrl();
		}
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<Orders>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							try {
								observer.next(new Orders(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}

	getOrderDetails(orderId: number): Observable<OrderResponseDetails> {
		const url: string = this.environment.GW_API + '/orders/' + orderId + '/details';
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<OrderResponseDetails>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						const result: OrderResponseDetails = new OrderResponseDetails();
						if (!Utilities.isVoid(response)) {
							result.responseStatus = response.status;
							if (!Utilities.isVoid(response) && response.status === 200) {
								result.value = new OrderDetails(response.json());
							}
						}
						observer.next(result);
					},
					error => {
						observer.error(error);
					});
			});
	}

	getOrderDetailsDKC(orderId: number, commodities: number): Observable<OrderResponseDetails> {
		const url: string = this.environment.GW_API + '/orders/' + orderId + '/details';
		const cm: number[] = [commodities];
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(
			this.permissionsService.getCurrentUserPermissions().isCenterSuperUserOperator(NemoModuleKeys.DELIVERY) ? (
					this.permissionsService.getCommoditiesFromItemMenuID(UserV3Model.DELIVERY_ITEM_MENU_ID).filter(
						commodity => commodity.ald_commodity_id !== CommodityModel.allCentersID
					).map(commodity => commodity.ald_supplier_id)
				) :
				cm
		);

		return new Observable<OrderResponseDetails>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						const result: OrderResponseDetails = new OrderResponseDetails();
						if (!Utilities.isVoid(response)) {
							result.responseStatus = response.status;
							if (!Utilities.isVoid(response) && response.status === 200) {
								result.value = new OrderDetails(response.json());
							}
						}
						observer.next(result);
					},
					error => {
						observer.error(error);
					});
			});
	}


	getOrderDeliveryChecks(orderId: number): Observable<OrderResponseChecks> {
		const url: string = this.environment.GW_API + '/orders/' + orderId + '/checks';
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<OrderResponseChecks>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						const result: OrderResponseChecks = new OrderResponseChecks();
						if (!Utilities.isVoid(response)) {
							result.responseStatus = response.status;
							if (!Utilities.isVoid(response) && response.status === 200) {
								result.value = DeliveryUtilities.sortCategoryChecks(response.json());
							}
						}
						observer.next(result);
					},
					error => {
						observer.error(error);
					});
			});
	}

	getShortOrderDeliveryChecks(orderId: number): Observable<Map<string, DeliveryChecksList>> {
		const url: string = this.environment.GW_API + '/orders/' + orderId + '/checks';
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());

		return new Observable<Map<string, DeliveryChecksList>>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {
							observer.next(DeliveryUtilities.sortCategoryChecksShort(response.json()));
						} else {
							observer.next(null);
						}
					},
					error => {
						console.error(error);
						observer.next(null);
					});
			});
	}

	getTyres(orderId: number, flag_delivery_tyres: boolean): Observable<OrderResponseTyres> {
		const url: string = this.environment.GW_API + '/orders/' + orderId + '/tyres?delivery=' + flag_delivery_tyres;
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		return new Observable<OrderResponseTyres>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						const result: OrderResponseTyres = new OrderResponseTyres();
						if (!Utilities.isVoid(response)) {
							result.responseStatus = response.status;
							if (!Utilities.isVoid(response) && response.status === 200) {
								result.value = new Tyres(response.json());
							}
						}
						observer.next(result);
					},
					error => {
						observer.error(error);
					});
			});
	}

	getDelivery(orderId: number): Observable<OrderResponseDelivery> {
		const url: string = this.environment.GW_API + '/orders/' + orderId + '/delivery';
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		return new Observable<OrderResponseDelivery>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						const result: OrderResponseDelivery = new OrderResponseDelivery();
						if (!Utilities.isVoid(response)) {
							result.responseStatus = response.status;
							if (!Utilities.isVoid(response) && response.status === 200) {
								result.value = new OrderDelivery(response.json());
							}
						}
						observer.next(result);
					},
					error => {
						observer.error(error);
					});
			});
	}

	//TODO remove

	getDeliveryToken(orderId: number, deliveryCertificateId: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderId + '/delivery/certificate/' + deliveryCertificateId;
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		return new Observable<Response>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						observer.next(response);
					},
					error => {
						console.error(error);
						observer.next(null);
					});
			});
	}

	getAllForDetails(orderId: number): Observable<[OrderResponseDetails, OrderResponseChecks, OrderResponseDelivery, OrderResponseTyres, OrderResponseTyres]> {
		return zip(
			this.getOrderDetails(orderId),
			this.getOrderDeliveryChecks(orderId),
			this.getDelivery(orderId),
			this.getTyres(orderId, false),
			this.getTyres(orderId, true)
		);
	}

	setOrderState(state: string, orderID: number, body: any): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/' + state;
		return this.sendPost(url, body);
	}

	setOrderDetails(orderID: number, body: any): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/details';
		return this.sendPost(url, body);
	}

	saveInsuranceDetails(orderID: number, body: any): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/details';
		return this.sendPost(url, body);
	}

	sendDelivery(orderID: number, body: any, certificate?: boolean): Observable<Response> {
		if (Utilities.isVoid(body) || Utilities.isVoid(body.id_order)) {
			return new Observable<Response>(observer => observer.error(null));
		} else {
			//TODO remove
			let url: string = this.environment.GW_API + '/orders/' + orderID + '/delivery';
			if (certificate) {
				url += '/certificate';
			}
			return this.sendPost(url, body);
		}
	}

	sendTyres(orderID: number, body: any, flag_delivery_tyres: boolean): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/tyres?delivery=' + flag_delivery_tyres;
		return this.sendPost(url, body);
	}

	sendCheck(orderID: number, checkID: number, body: any): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/checks/' + checkID;
		return this.sendPost(url, body);
	}

	//TODO change
	sendAcceptingDelivery(orderID: number, body: any, deliveryCertificateId: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/delivery/certificate/' + deliveryCertificateId + '/accept';
		return this.sendPost(url, body);
	}

	createDocument(orderID: number, body: any, document_type: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/delivery/' + document_type + '/create';
		return this.sendPost(url, body);
	}

	private sendPost(url: string, body: any): Observable<Response> {
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		options.method = RequestMethod.Post;
		options.headers.set('Content-Type', 'application/json');

		return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, options);
	}

	getCertificate(orderID: number, tokenForDownload: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/delivery/certificate/download/' + tokenForDownload;
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		options.responseType = ResponseContentType.Blob;
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
	}

	getInsuranceCertificates(orderID: number, plate: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/insurance_certificates/' + plate;
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
	}

	getRegistrationBooks(orderID: number, plate: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/registration_books/' + plate;
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
	}

	downloadInsuranceCertificatesOrRegistrationBooks(orderID: number, vendorDocumentType: string, vendorDocumentId: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/' + vendorDocumentType + '/' + vendorDocumentId + '/download';
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		options.responseType = ResponseContentType.Blob;
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
	}

	getDeliveryTyreHasBeenCleanedSubject(): Subject<boolean> {
		return this.deliveryTyreHasBeenCleanedSubject;
	}

	getSystemCode(): Observable<{ code_name: string, codes: { code: string, value: string }[] }[]> {
		const options: RequestOptionsArgs = Utilities.setRequestOptionGW(this.selectCommoditiesService.getAldCommodityIds());
		return this.httpAuthService.get(
			`${this.environment.GW_API}/system/codes`,
			this.environment.ROOT_REDIRECT,
			options
		).pipe(
			tap(
				response => {
					if (!response.ok) {
						throw response;
					}
				}
			), map(response => response.json()),
			// tslint:disable-next-line:no-unnecessary-callback-wrapper
			catchError(err => throwError(err))
		);
	}

	signAndAcceptingDelivery(orderID: number, signBody: any, dossierId: string, signerId: string, deliveryCertificateId: string): Observable<Response> {
		const url: string = this.environment.GW_API + '/orders/' + orderID + '/delivery/certificate/dossier/' + dossierId + '/signandaccept';
		return this.sendPost(
			url, 
			{	
				sign: signBody,
				certificate_id: deliveryCertificateId,
				signer_id: signerId,
				citizenship: this.citizenship,
				place_document_issue: this.place_document_issue,
				delegate_citizenship: this.delegate_citizenship,
				delegate_place_document_issue: this.delegate_place_document_issue
			 });
	}
}

